import React, { useContext, Fragment, useEffect } from "react";
import { TemplateWhatsAppBlipContext } from "../TemplateWhatsAppBlipContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarTemplateWhatsAppBlip = () => {
  const { values, setValues, resetScreen } = useContext(TemplateWhatsAppBlipContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={TemplateWhatsAppBlipContext}>
        <div className="col-12 col-md-3">
          <label>Nome</label>
          <input
            className="form-control"
            type="text"
            name="templateWhatsAppBlipNome"
            value={values.searchData.templateWhatsAppBlipNome}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={TemplateWhatsAppBlipContext} />
    </Fragment>
  );
};

export default PesquisarTemplateWhatsAppBlip;
